<template>
  <div class="Pagination">
    <el-pagination
      background
      @size-change="onPageSizeChange"
      @current-change="onCurrentPageChange"
      :current-page="pageOption.page"
      :page-sizes="pageOption.pageSizes"
      :page-size="pageOption.offset"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pageOption.total"
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: "Pagination",
  props: {
    pageOption: {
      type: Object,
      required: true,
    },
  },
  methods: {
    onPageSizeChange(val) {
      this.$emit("onPageSizeChange", val);
    },
    onCurrentPageChange(val) {
      this.$emit("onCurrentPageChange", val);
    },
  },
};
</script>
<style scoped lang="scss">
.Pagination {
  .el-pagination {
    margin-top: 15px;
    text-align: right;
    padding-right: 40px;
  }
}
::v-deep .el-pagination__editor.el-input .el-input__inner {
  color: #666666;
}
::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #1f93ff;
}
</style>
